<template>
  <!-- 不記名投票頁面 -->
  <div>
    <div id="NotRecordNameVoting_main">
      <div class="main assembly-main">
        <div class="title">
          {{ topicDashboardData.assemblyTitle }}
        </div>
        <div class="refreshTxt">
          統計最後更新時間：{{ refreshTime }}
        </div>
      </div>
      <TopicDashboard
        :data="topicDashboardData"
        @refresh="refresh"
      />
      <VoteDashboard
        :data="voteDashboardData"
        :show-scan="false"
      />
    </div>
    <NotRecordNameWriteVotes
      v-if="topicDashboardData.topicStatus == 'voting'"
      ref="notRecordNameWriteVotes"
      :data="options"
      :tablet-value="topicDashboardData.tabletValue"
      @refresh="refresh"
    />
  </div>
</template>
<script>
import TopicDashboard from './components/vote/TopicDashboard.vue'
import VoteDashboard from './components/vote/VoteDashboard.vue'
import NotRecordNameWriteVotes from './components/vote/NotRecordNameWriteVotes.vue'
export default {
  components: {
    TopicDashboard,
    VoteDashboard,
    NotRecordNameWriteVotes
  },
  beforeRouteLeave (to, from, next) {
    if (this.$refs.notRecordNameWriteVotes) { this.$refs.notRecordNameWriteVotes.clearInterval() }
    next()
  },
  data () {
    return {
      refreshTime: '',
      topicDashboardData: {}, // 議案資料
      voteDashboardData: [], // 投票統計資料
      options: [] // 輸入投票資料
    }
  },
  mounted () {
    this.getData()
    this.getVoteData()
    previousPage = { name: 'AssemblyRegister', params: { id: this.$route.params.id } } // header 上一頁路徑
  },
  methods: {
    getData () {
      apiUnitOwnerAssembly.Vote.GetVotingDashboardData(
        {
          assemblyId: this.$route.params.id,
          topicId: this.$route.params.topicId
        }
      ).then(res => {
        console.log(res)
        // eslint-disable-next-line eqeqeq
        if (res.status == 200) {
          this.topicDashboardData = res.data
          if (this.topicDashboardData.topicStatus !== 'voting' && this.$refs.notRecordNameWriteVotes) { // 議案未在表決中
            this.$refs.notRecordNameWriteVotes.clearInterval()
          }
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
      this.refreshTime = this.$newFormatDate(new Date())
    },
    getVoteData () {
      apiUnitOwnerAssembly.Vote.GetVotes(
        {
          assemblyId: this.$route.params.id,
          topicId: this.$route.params.topicId
        }
      ).then(res => {
        console.log(res)
        // eslint-disable-next-line eqeqeq
        if (res.status == 200) {
          this.voteDashboardData = []
          this.options = []
          res.data.optionVotingResults.forEach(item => {
            this.voteDashboardData.push({
              id: item.id,
              content: item.content,
              votesArea: item.votesArea,
              votesNumber: item.votesNumber,
              votesRatio: item.votesRatio
            })
            if (item.id) {
              this.options.push({
                id: item.id,
                content: item.content,
                votesNumber: 0
              })
            }
          })
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    refresh () {
      this.getData()
      this.getVoteData()
    }
  }
}
</script>
<style lang='sass' scoped>
#NotRecordNameVoting_main
  +mainLayer
  .assembly-main
    padding-top: 24px
    padding-bottom: 16px
    .title
      word-wrap: break-word
      color: $mainFontColor
      font-size: 25px
      font-weight: 600
      line-height: 35px
    .refreshTxt
      margin-top: 8px
      font-size: 17px
      color: $hintColor
      line-height: 24px
</style>
